import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";
import ContactUs from "./pages/ContactUs";
import ErrorPage from "./pages/ErrorPage";
import SuccessPage from "./pages/SuccessPage";
import PayWithVenmo from "./pages/Venmo";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/paypal" element={<PayWithVenmo />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route path="/contactus" element={<ContactUs />} />
      </Routes>
    </Router>
  );
}

export default App;
